import React, { useEffect, useRef, useState } from "react";
import "../HomeWork/HomeWork.css";
import "../PreRead/PreRead.css";
import "../Activity/Activity.css";
import SubjBoxProps from "../Activity/Subj_Box/SubjBoxProps";
import FilterBox from "../PreRead/Filter_Box/FilterBox";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "../../axios";
import SortedBy from "../PreRead/Filter_Box/SortedBy";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import ActivityTour from "../../SidebarHeader/Header/ActivityTour";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { shortenParagraph } from "../../utils/Engagement";

// Subject icon mapper
const getSubjectIcon = (subjectName = "") => {
  const name = subjectName.toLowerCase().trim();
  if (["maths", "mathematics", "math"].some((s) => name.includes(s))) {
    return "/ActivityIcons/Maths_Lab_Icon-removebg-preview.png";
  }
  if (["english"].some((s) => name.includes(s))) {
    return "/ActivityIcons/English_Lab_Icon.png";
  }
  if (["hindi"].some((s) => name.includes(s))) {
    return "/ActivityIcons/Hindi_Lab_Icon-removebg-preview.png";
  }
  if (
    ["science", "physics", "chemistry", "biology", "botany", "zoology"].some(
      (s) => name.includes(s),
    )
  ) {
    return "/ActivityIcons/Science_Lab_Icon-removebg-preview.png";
  }
  return "/ActivityIcons/Any_others_Subjects_Lab_Icon-removebg-preview.png";
};

const hexToRgb = (hex) => {
  const cleanHex = hex.replace("#", "");
  const bigint = parseInt(cleanHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

const getSubjectGradient = (subjectColor = "4169E1") => {
  const hex = subjectColor.startsWith("#") ? subjectColor : `#${subjectColor}`;
  const { r, g, b } = hexToRgb(hex);
  const lightR = Math.min(255, r + 210);
  const lightG = Math.min(255, g + 210);
  const lightB = Math.min(255, b + 210);
  const medR = Math.min(255, r + 160);
  const medG = Math.min(255, g + 160);
  const medB = Math.min(255, b + 160);
  const ultraR = Math.min(255, r + 235);
  const ultraG = Math.min(255, g + 235);
  const ultraB = Math.min(255, b + 235);
  return `linear-gradient(145deg, 
    rgba(${lightR}, ${lightG}, ${lightB}, 0.9) 0%, 
    rgba(${medR}, ${medG}, ${medB}, 0.6) 50%,
    rgba(${ultraR}, ${ultraG}, ${ultraB}, 0.3) 100%)`;
};

const getSubjectBadgeStyle = (subjectColor = "4169E1") => {
  const hex = subjectColor.startsWith("#") ? subjectColor : `#${subjectColor}`;
  const { r, g, b } = hexToRgb(hex);
  return {
    backgroundColor: `rgba(${r}, ${g}, ${b}, 0.12)`,
    color: hex,
    border: `1px solid rgba(${r}, ${g}, ${b}, 0.25)`,
  };
};

export default function ActivityMain({ type }) {
  const [homeMain, setHomeMain] = useState({
    subMenu: localStorage.getItem("actSub") || "pending",
    activeData: null,
    ActivitypendingSubDetail: false,
    ActivityOnReviewSubDetail: false,
    ActivityCompletedSubDetail: false,
  });
  const navigate = useNavigate();
  const popupRef = useRef(null);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [isSortPop, setIsSortPop] = useState(false);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const toggleFilterPopup = () => setIsPopupOpen((prev) => !prev);
  const togglePopup = () => setIsSortPop(!isSortPop);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };
    if (isPopupOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isPopupOpen]);

  const { state } = useLocation();
  useEffect(() => {
    const hasShownPopup = localStorage.getItem("hasShownPopupActivity");
    if (!hasShownPopup) {
      setHomeScreenWalkThroughPopup(true);
      localStorage.setItem("hasShownPopupActivity", "true");
    }
  }, []);

  const [steps, setSteps] = useState([
    {
      element: ".FoterDetailContainer",
      intro: `<h3>Parent Features Bottom Pane</h3><p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Homework' parent is selected.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".homeWork",
      intro: `<h3>Smart.Homework</h3><p>Smart.Homework has 4 features (as shown in left most pane):</p><ol><li>Homework</li><li>Pre-Read</li><li>Activity</li></ol>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneHWM",
      intro: `<h3>Features Group Left Pane</h3><p>Smart.Homework has 3 features as shown:</p><ol><li>Homework</li><li>Pre-Read</li><li>Activity</li></ol>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".activity",
      intro: `<h3>Activity</h3><p>Currently 'Pre-Read' feature is selected, Let's navigate through this feature</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".subWiseA ",
      intro: `<h3>Subject Wise Activity</h3><p>You can see subject wise Activity count for 'pending', 'review' and 'completed'</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".CardsA  ",
      intro: `<h3>Cards Section</h3><p>You can open Activities from this section.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".pendingA",
      intro: `<h3>Pending</h3><p>In this tab you will find Activities which needs to be submitted by you.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".reviewA",
      intro: `<h3>On Review</h3><p>You will find your submitted Activities which are yet to be reviewed by teacher.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".completedA",
      intro: `<h3>Completed</h3><p>You will find your submitted Ativities which are reviewed by teacher.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".filterA",
      intro: `<h3>Filter</h3><p>Using filter button you can filter items by subject time and date wise.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".sortByA",
      intro: `<h3>Sort By</h3><p>Using Sort by Button you can sort items in ascending or descending based on date.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `<h3>Your profile, B4S App layout</h3><p>Access your profile Information.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `<h3>Awesome, you are done. 😊</h3><p>Click anywhere on the screen or click on the cross icon.</p>`,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);
  const onExit = () => setStepsEnabled(false);
  const [noContentClick, setNoContentClick] = useState(false);
  const [cards, setCards] = useState([]);
  const [rotation, setRotation] = useState(0);
  const rotateImage = () => setRotation((rotation) => rotation + 180);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    sortBy: -1,
    limit: 20,
    page: 1,
  });
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    const pendingBox = async () => {
      setIsGettingData(true);
      let response = await axios.get(
        `/homework/activity/filterByStudentId/${currentUser?.id}/${homeMain.subMenu}?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
          `${filter?.date ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}` : ``}` +
          `${filter?.time ? `&time=${filter?.time}` : ``}` +
          `${filter?.subjectId?.length !== 0 ? `&subjectId=${filter?.subjectId}` : ``}`,
      );
      response && setCards(response.data.data);
      setIsGettingData(false);
    };
    pendingBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, homeMain.subMenu]);

  const handlePendingActivitySubDetail = () => {
    setHomeMain({
      ...homeMain,
      subMenu: "pending",
      ActivitypendingSubDetail: false,
    });
  };
  const handlePendingOnreviewSubDetail = () => {
    setHomeMain({
      ...homeMain,
      subMenu: "review",
      ActivityOnReviewSubDetail: false,
    });
  };
  const handlePendingCompletedSubDetail = () => {
    setHomeMain({
      ...homeMain,
      subMenu: "completed",
      ActivityCompletedSubDetail: false,
    });
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000;
    const localDate = new Date(dateObj - userOffset);
    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Reusable card component — FIXED bottom row layout
  const ActivityCard = ({ card, onClick, bottomLabel, isDelayed }) => {
    const subjectName = card?.subject_id?.name || "";
    const subjectColor = card?.subject_id?.subject_color || "4169E1";
    const activityName = card?.name || "";
    const subjectIcon = getSubjectIcon(subjectName);
    const cardGradient = getSubjectGradient(subjectColor);
    const badgeStyle = getSubjectBadgeStyle(subjectColor);

    return (
      <div
        onClick={onClick}
        className="d-flex flex-column shadow-sm rounded-4 overflow-hidden position-relative cursor-pointer"
        style={{
          background: cardGradient,
          border: "1px solid rgba(255,255,255,0.7)",
          borderRadius: "1rem",
          minHeight: "150px",
          width: "300px",
          transition: "transform 0.25s ease, box-shadow 0.25s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 16px 32px rgba(0,0,0,0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "";
        }}
      >
        {/* Main content */}
        <div className="d-flex flex-row justify-content-between px-3 pt-3 flex-grow-1">
          {/* Left: Title + Badge */}
          <div className="d-flex flex-column" style={{ flex: 1, minWidth: 0 }}>
            {/* Title */}
            <Tooltip
              title={activityName}
              arrow
              placement="bottom"
              enterDelay={200}
              leaveDelay={100}
            >
              <h6
                className="poppins-semibold mb-2"
                style={{ fontSize: "1rem", color: "#2d2d2d", lineHeight: 1.3 }}
              >
                {shortenParagraph(activityName, 28)}
              </h6>
            </Tooltip>

            {/* Subject badge */}
            <span
              className="badge rounded-pill px-2 py-1 align-self-start"
              style={{ fontSize: "0.7rem", fontWeight: 600, ...badgeStyle }}
            >
              {`${card?.standard_id?.name || ""} - ${card?.section_id?.name || ""} | ${shortenParagraph(subjectName, 20)}`}
            </span>

            {/* Spacer pushes icon area down */}
            <div style={{ flex: 1, minHeight: "8px" }} />

            {/* Bottom row: Label left + Delayed badge right (FIXED) */}
            <div className="d-flex justify-content-between align-items-center mb-1">
              <div
                className="d-flex align-items-center"
                style={{ fontSize: "0.8rem", color: "#666" }}
              >
                <span className="me-1" style={{ fontSize: "0.85rem" }}>
                  {bottomLabel.icon}
                </span>
                <span>{bottomLabel.text}: </span>
                <span className="ms-1 fw-medium text-dark">
                  {bottomLabel.value}
                </span>
              </div>

              {/* Delayed badge inline instead of absolute */}
              {isDelayed && (
                <span
                  className="ms-2"
                  style={{
                    color: "#dc2626",
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    backgroundColor: "rgba(220, 38, 38, 0.08)",
                    padding: "2px 8px",
                    borderRadius: "4px",
                    whiteSpace: "nowrap",
                    border: "1px solid rgba(220, 38, 38, 0.15)",
                  }}
                >
                  {isDelayed}
                </span>
              )}
            </div>
          </div>

          {/* Right: Subject illustration */}
          <div
            className="d-flex align-items-center ms-2"
            style={{
              width: "70px",
              height: "70px",
              flexShrink: 0,
              marginTop: "4px",
            }}
          >
            <img
              src={subjectIcon}
              alt={subjectName}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </div>
        </div>

        {/* Bottom padding */}
        <div className="pb-2" />
      </div>
    );
  };

  return (
    <>
      <div className="h-100">
        <Steps
          enabled={stepsEnabled}
          steps={steps}
          initialStep={initialStep}
          onExit={onExit}
        />
        <div className="pending_completed_container1 relative ">
          <div className="text-2xl font-semibold text-blue-950">
            Subject-wise Activity
          </div>
          <div className="subjectBoxContainer mt-3 subWiseA">
            <SubjBoxProps />
          </div>

          <div className="homeWorkSubContainer">
            <div className="d-flex ">
              <div className="d-flex mt-3 col-3 p-0 HomeWorkSubPartsMenuTotal">
                <div
                  className={
                    homeMain.subMenu === "pending"
                      ? "HomeWorkSubPartsMenuActive pendingA"
                      : "HomeWorkSubPartsMenu pendingA"
                  }
                  onClick={() => {
                    homeMain.subMenu !== "pending" && setCards([]);
                    setHomeMain({ ...homeMain, subMenu: "pending" });
                    localStorage.setItem("actSub", "pending");
                  }}
                >
                  Pending
                </div>
                <div
                  className={
                    homeMain.subMenu === "review"
                      ? "HomeWorkSubPartsMenuActive d-flex justify-content-center mr-3 reviewA"
                      : "HomeWorkSubPartsMenu mr-3 d-flex justify-content-center reviewA"
                  }
                  onClick={() => {
                    homeMain.subMenu !== "review" && setCards([]);
                    setHomeMain({ ...homeMain, subMenu: "review" });
                    localStorage.setItem("actSub", "review");
                  }}
                >
                  On Review
                </div>
                <div
                  className={
                    homeMain.subMenu === "completed"
                      ? "HomeWorkSubPartsMenuActive d-flex justify-content-center completedA"
                      : "HomeWorkSubPartsMenu d-flex justify-content-center completedA"
                  }
                  onClick={() => {
                    homeMain.subMenu !== "completed" && setCards([]);
                    setHomeMain({ ...homeMain, subMenu: "completed" });
                    localStorage.setItem("actSub", "completed");
                  }}
                >
                  Completed
                </div>
              </div>
              <div className="d-flex gap-4 align-items-center justify-content-end col-8 horizontalLine p-0 ">
                <div className="mb-3 filterA">
                  <div
                    className="col-md-12 gap-2 filter_box"
                    onClick={toggleFilterPopup}
                  >
                    <img
                      className="filter_icon"
                      src="/HwImg/filter Icon.svg"
                      alt=""
                    />
                    <span>Filter</span>
                  </div>
                </div>
                <div
                  className="d-flex gap-2 align-items-center mb-3 sortByA"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    togglePopup();
                    rotateImage();
                  }}
                >
                  <div className="sortby">Sort by</div>
                  <div>
                    <img
                      src="/HwImg/DownArrowSort.png"
                      alt=""
                      style={{ transform: `rotate(${rotation}deg)` }}
                    ></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="pending_completed_container2 mt-4 orange-scrollBar CardsA"
          style={{
            maxHeight: "50vh",
            overflowY: "scroll",
            paddingBottom: "5px",
          }}
        >
          {/* PENDING */}
          {homeMain.subMenu === "pending" && (
            <>
              {cards.length > 0 ? (
                <div className="d-flex flex-wrap gap-3">
                  {cards.map((card, index) => (
                    <ActivityCard
                      key={index}
                      card={card}
                      onClick={() => {
                        setHomeMain({
                          ...homeMain,
                          ActivitypendingSubDetail: true,
                          activeData: card,
                        });
                        navigate(`/publishedActivity`, {
                          state: { activityId: card?.id },
                        });
                      }}
                      bottomLabel={{
                        icon: "⏰",
                        text: "Deadline",
                        value: timeHelper(card?.deadline),
                      }}
                      isDelayed={
                        moment(card?.deadline).format("YYYY-MM-DD") < today
                          ? "Delayed"
                          : null
                      }
                    />
                  ))}
                </div>
              ) : isGettingData ? (
                <img
                  className="ongoing_loader"
                  src="/gif/LoaderDot.gif"
                  alt=""
                />
              ) : (
                <div className="d-flex justify-content-center h-20 align-items-center w-100">
                  <span
                    className="badge bg-light text-dark rounded-pill px-4 py-3"
                    style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
                  >
                    📭 Activity Not Found
                  </span>
                </div>
              )}
            </>
          )}

          {/* ON REVIEW */}
          {homeMain.subMenu === "review" && (
            <>
              {cards.length > 0 ? (
                <div className="d-flex flex-wrap gap-3">
                  {cards.map((card, index) => (
                    <ActivityCard
                      key={index}
                      card={card}
                      onClick={() =>
                        navigate(`/reviewActivity`, {
                          state: { activityId: card?.id },
                        })
                      }
                      bottomLabel={{
                        icon: "📝",
                        text: "Submitted",
                        value: timeHelper(card?.submitted_on),
                      }}
                      isDelayed={
                        moment(card?.deadline).format("YYYY-MM-DD") <
                        moment(card?.submitted_on).format("YYYY-MM-DD")
                          ? "Delay Submit"
                          : null
                      }
                    />
                  ))}
                </div>
              ) : isGettingData ? (
                <img
                  className="ongoing_loader"
                  src="/gif/LoaderDot.gif"
                  alt=""
                />
              ) : (
                <div className="d-flex justify-content-center h-20 align-items-center w-100">
                  <span
                    className="badge bg-light text-dark rounded-pill px-4 py-3"
                    style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
                  >
                    📭 Activity Not Found
                  </span>
                </div>
              )}
            </>
          )}

          {/* COMPLETED */}
          {homeMain.subMenu === "completed" && (
            <>
              {cards.length > 0 ? (
                <div className="d-flex flex-wrap gap-3">
                  {cards.map((card, index) => (
                    <ActivityCard
                      key={index}
                      card={card}
                      onClick={() =>
                        navigate(`/completedActivity`, {
                          state: { activityId: card?.id },
                        })
                      }
                      bottomLabel={{
                        icon: "✅",
                        text: "Submitted",
                        value: timeHelper(card?.submitted_on),
                      }}
                      isDelayed={
                        moment(card?.deadline).format("YYYY-MM-DD") <
                        moment(card?.submitted_on).format("YYYY-MM-DD")
                          ? "Delayed Submission"
                          : null
                      }
                    />
                  ))}
                </div>
              ) : isGettingData ? (
                <img
                  className="ongoing_loader"
                  src="/gif/LoaderDot.gif"
                  alt=""
                />
              ) : (
                <div className="d-flex justify-content-center h-20 align-items-center w-100">
                  <span
                    className="badge bg-light text-dark rounded-pill px-4 py-3"
                    style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
                  >
                    📭 Activity Not Found
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {homeScreenWalkThroughPopup && (
        <ActivityTour
          setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
          setStepsEnabled={setStepsEnabled}
        />
      )}
      {isPopupOpen && (
        <div ref={popupRef}>
          <FilterBox
            setFilter={setFilter}
            filter={filter}
            toggleFilterPopup={toggleFilterPopup}
            type={type}
          />
        </div>
      )}

      {isSortPop && (
        <SortedBy
          filter={filter}
          setFilter={setFilter}
          togglePopup={togglePopup}
          type={type}
        />
      )}
    </>
  );
}
